import { Box, Button } from '@chakra-ui/react';

import { AnimatePresence, motion } from 'framer-motion';
import React, { useEffect, useState } from 'react';
import { Send } from 'iconoir-react';

interface SubmitConversationButtonProps {
  ariaLabel: string;
  onClick: () => void;
  loading: boolean;
  disabled: boolean;
  isReady: boolean;
}

const MotionButton = motion.create(Button);

export const SubmitConversationButton: React.FC<SubmitConversationButtonProps> = ({
  ariaLabel,
  onClick,
  loading,
  disabled,
  isReady,
}) => {
  const [showExpandedButton, setShowExpandedButton] = useState(isReady);

  useEffect(() => {
    if (isReady) {
      // When isReady becomes true, immediately show expanded button
      setShowExpandedButton(true);
    }
    // When isReady becomes false, we'll wait for the text to disappear before collapsing
  }, [isReady]);

  const handleTextExitComplete = () => {
    if (!isReady) {
      setShowExpandedButton(false);
    }
  };

  return (
    <MotionButton
      aria-label={ariaLabel}
      size="md"
      onClick={onClick}
      loading={loading}
      disabled={disabled}
      rounded="full"
      px={showExpandedButton ? 3 : 0}
      colorPalette="primary"
      variant="solid"
      transition={{
        type: 'spring',
        stiffness: 600,
        damping: 40,
        mass: 0.8,
      }}
      display="flex"
      alignItems="center"
      justifyContent="center"
      gap={1.5}
      _hover={{ bg: 'primary.focusRing' }}
      whileTap={{ scale: 0.96 }}
      whileHover={{ scale: 1.04 }}
      initial={false}
    >
      <Box as="span" display="inline-flex" color="white">
        <Send width={20} height={20} />
      </Box>
      <AnimatePresence onExitComplete={handleTextExitComplete}>
        {isReady && !loading && (
          <motion.span
            style={{ color: 'white', fontWeight: 500, fontSize: '0.875rem' }}
            initial={{ opacity: 0, x: 8 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: 8, transition: { duration: 0.12 } }}
            transition={{ type: 'spring', stiffness: 400, damping: 30 }}
          >
            Send
          </motion.span>
        )}
      </AnimatePresence>
    </MotionButton>
  );
};
